import React, { useEffect, useRef } from "react";
import Header from "../component/header";
import Footer from "../component/footer";
import Banner from "../component/hiredevelopers/banner";
import Client from "../component/hiredevelopers/client";
import Candidateskills from "../component/hiredevelopers/candidateskills";
import Roles from "../component/hiredevelopers/roles";
import Testimonial from "../component/hiredevelopers/testimonial";
import Faq from "../component/hiredevelopers/faq";
import SingleClick from "../component/hiredevelopers/singleclick";

const Hiredevelopers = () => {
  useEffect(() => {
    document.body.className = "";
    document.title =
      "Hire The Highly Skilled Remote Developers | Hire Remote Team";
    document.querySelector("meta[name='description']").content =
      "Hire highly skilled remote developers, 3 - 5+ Years of Experience preferable that you can rely on and which synchronizes with your time zone. Contact us!";
  }, []);

  const scrollToDiv = (ref) =>
    ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
  const el1 = useRef();

  return (
    <>
      <Header />
      <Banner scrollToDiv={scrollToDiv} el1={el1} />
      <Client />
      <Candidateskills />
      <Roles />
      <Testimonial />
      <Faq />
      <SingleClick reference={el1} />
      <Footer />
    </>
  );
};

export default Hiredevelopers;
